module.exports = __webpack_public_path__ + "static/media/AndHeartTrackLogo.dc4988c4.svg";